import { DateQualifierService } from 'src/app/model/api-services/qualifiers/date-qualifier.service';
import { Comparisons, COMPARE } from 'src/app/types/@types/comparisons';
import { DateBuffer } from '../components/criteria/date-buffer/date-buffer.component';
import { mSecondsFromEpoch } from '../types/@types/sl-v-types';
import { SearchCriterion } from '../types/search-criteria';

export type DateDeltas = [number, number, number];

export class DateUtil {
	static YEARS = 0;
	static MONTHS = 1;
	static DAYS = 2;
	static DateBufferToCriterion(field: string, info: DateBuffer, not	: boolean = false): SearchCriterion {
		const comparison: string = (not === true) ? COMPARE.DATE_NOT_BETWEEN : COMPARE.DATE_BETWEEN;
		const criterion: SearchCriterion = { field: (field), compare: comparison, value: '', casting: 'date' };
		const targetDate = info.targetDate;
		const deltas: DateDeltas = [0, 0, 0] as DateDeltas;
		switch (info.bufferInfo.which) {
			case 'days':
				deltas[DateUtil.DAYS] = info.bufferInfo.count;
				break;
			case 'weeks':
				deltas[DateUtil.DAYS] = (info.bufferInfo.count * 7);
				break;
			case 'months':
				deltas[DateUtil.MONTHS] = info.bufferInfo.count;
				break;
			case 'years':
				deltas[DateUtil.YEARS] = info.bufferInfo.count;
				break;
		}
		let minDate = new Date(targetDate);
		let maxDate = new Date(targetDate);
		switch (info.bufferInfo.range) {
			case '-+':
				minDate = DateUtil.SubtractFromDate(minDate, deltas);
				maxDate = DateUtil.AddToDate(maxDate, deltas);
				break;
			case '-':
				minDate = DateUtil.SubtractFromDate(minDate, deltas);
				break;
			case '+':
			default:
				maxDate = DateUtil.AddToDate(maxDate, deltas);
				break;
		}
		criterion.casting = 'date';
		criterion.value = DateQualifierService.DateToDB(minDate) + ',' + DateQualifierService.DateToDB(maxDate);
		return criterion;
	}
	static ToAbs(date: Date): number {
		return date.valueOf() / 1000;
	}
	static FromAbs(abs: number) {
		return new Date(abs * 1000);
	}
	static SubtractFromDate(date: Date, deltas: DateDeltas) {
		return new Date(
			date.getFullYear() - deltas[DateUtil.YEARS],
			date.getUTCMonth() - deltas[DateUtil.MONTHS],
			date.getUTCDate() - deltas[DateUtil.DAYS]
		);
	}
	static AddToDate(date: Date, deltas: DateDeltas) {
		return new Date(
			date.getFullYear() + deltas[DateUtil.YEARS],
			date.getUTCMonth() + deltas[DateUtil.MONTHS],
			date.getUTCDate() + deltas[DateUtil.DAYS]
		);
	}

	static GetDayOfWeek(target: Date): number {
		return target.getDay();
	}
	static GetDayOfMonth(target: Date): number {
		return target.getDate();
	}
	static GetDayOfYear(target: Date): number {
		return (Date.UTC(target.getFullYear(), target.getMonth(),
			target.getDate()) - Date.UTC(target.getFullYear(), 0, 1)) / 24 / 60 / 60 / 1000;
	}
	static GetWeekOfYear(target: Date): number {
		const firstOfYear = new Date(target.getFullYear(), 0, 1);
		return Math.floor(1 + (+target - +firstOfYear) / 604800000);
	}
	static GetMonthOfYear(target: Date): number {
		return target.getMonth() + 1;
	}





}
